import './AccessDeniedPage.css'
import { Link} from 'react-router-dom'

export function AccessDeniedPage() {
    return (
      <div className="fullscreen-block">
        <h1>403 - Доступ запрещен</h1>
        <p>У вас недостаточно прав для просмотра этой страницы</p>
        <Link to="/">Вернуться на главную</Link>
      </div>
    );
  }